import { BlogPost } from '@/types/blog';
import { Clock } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Card, CardContent, CardHeader } from '../ui/card';

interface BlogCardProps {
  post: BlogPost;
}

export default function BlogCard({ post }: BlogCardProps) {
  const readingTime = Math.ceil(post.content.split(' ').length / 200);

  return (
    <Card
      className="overflow-hidden hover:shadow-lg transition-all duration-300 h-full border border-gray-100 group"
    >
      <div className="relative">
        {post.image && (
          <div className="aspect-video overflow-hidden">
            <img
              src={post.image}
              alt={post.title}
              className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-500"
            />
          </div>
        )}
      </div>
      <CardHeader className="pb-2">
        <div className="flex flex-wrap gap-2 mb-3">
          {post.tags.map((tag) => (
            <Badge key={tag} variant="secondary" className="bg-blue-50 text-blue-700 hover:bg-blue-100">
              {tag}
            </Badge>
          ))}
        </div>
        <h3 className="text-xl font-bold mb-2 group-hover:text-[#0074b7] transition-colors line-clamp-2">
          {post.title}
        </h3>
      </CardHeader>
      <CardContent>
        <p className="text-gray-600 line-clamp-3 mb-4">
          {post.description}
        </p>
        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
          <span className="text-sm text-gray-500">By {post.author}</span>
          <div className="flex items-center text-sm text-gray-500">
            <Clock className="h-4 w-4 mr-1" />
            <span>{readingTime} min read</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
